import styled from 'styled-components';
import { Button, Flexbox, Toast } from '@hiiretail/synergy-ui';

export const PageWrapper = styled(Flexbox)`
  display: flex;
  flex: 1;
  justify-content: center;
`;

export const PageContainer = styled(Flexbox)`
  width: 400px;
  height: max-content;
  border-radius: 6px;
  box-shadow: 0 2px 16px 0 rgba(33, 43, 54, 0.08), 0 31px 41px 0 rgba(33, 43, 54, 0.2);
  padding: ${(props) => props.theme.spacing(6)}px;
  margin: ${(props) => props.theme.spacing(6)}px;
  form {
    width: 100%;
  }
`;

export const Logo = styled.img`
  width: 60%;
  height: auto;
  margin-bottom: ${(props) => props.theme.spacing(4)}px;
`;

export const LoginBtn = styled(Button)`
  width: 100%;
`;

export const StyledToast = styled(Toast)`
  max-width: 400px;
  span {
    line-height: unset !important;
  }
`;
